

















import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import * as Constants from "@/Constants";
import _ from "lodash";
import { Request } from "@/modules/request/Request";
import { Getter } from "vuex-class";
import Owner from "@/model/cospirit-api/Owner";

const components = {
};

@Component({components})
export default class AreaZones extends Vue {
    @Getter("getCurrentOwner") public currentOwner!: Owner;

    @Prop(Object) private request!: Request;

    public valueOptionsZone: string[] = [];
    public optionsZone: any = [];

    @Watch("request", {immediate: true, deep: true}) private watchRequest() {
        this.valueOptionsZone = this.request.area ? this.request.area.split(",") as any : "";
    }
    private mounted(): void {
        this.optionsZone = _.find(Constants.optionsZone,
            (e: any) => e.canonical_name === this.currentOwner.canonicalName);
        this.valueOptionsZone = this.request.area ? this.request.area.split(",") as any : "";
    }

    public arrayFilter(value: any) {
        const zoneOption = _.find(this.optionsZone.options, (option) => {
            return option.key === value;
        });

        if (zoneOption && zoneOption.selectUnique) {
            this.valueOptionsZone = [value];
        }

        if (zoneOption && false === zoneOption.selectUnique) {
            _.forEach(this.valueOptionsZone, (optionSelected, idx) => {
                const optionValue = _.find(this.optionsZone.options, (option) => {
                    return option.key === optionSelected;
                });
                if (optionValue?.selectUnique) {
                    this.valueOptionsZone.splice(idx, 1);
                }
            });
        }
        this.request.area = this.valueOptionsZone.join(",");
    }
}
